<template>
  <article id="products">
    <div
      class="product-cards"
      :class="{ 'cards-center': centered }"
      v-show="!showProducts"
    >
      <product
        v-for="(product, index) in products"
        :key="product.id"
        :product="product"
        :index="index"
        :orderFreeSwatchBtn="true"
        :isSearchPage="false"
        @add-swatch-to-cart="addSwatchToCart"
      />
    </div>

    <infinite-loading
      spinner="waveDots"
      :identifier="infiniteId"
      @infinite="onInfinite"
      :distance="20"
    >
      <div
        class="no-more"
        slot="no-more"
        v-if="Object.keys(products).length <= 0"
      >
        <i class="fa fa-search" aria-hidden="true"></i>
        <h4>No items were found.</h4>
        <a class="btn btn-blue" href="javascript:void(0)" @click="resetFilters">
          Try again
        </a>
      </div>
      <div slot="no-more" v-else></div>
      <div
        class="no-results"
        slot="no-results"
        v-if="Object.keys(products).length <= 0 && !showProducts"
      >
        <i class="fa fa-search" aria-hidden="true"></i>
        <h4>No items were found.</h4>
        <a class="btn btn-blue" href="javascript:void(0)" @click="resetFilters">
          Try again
        </a>
      </div>
      <div slot="no-results" v-else></div>
    </infinite-loading>
    <a
      href=""
      @click.prevent="scrollTo('#vue-shop')"
      class="back-to-top"
      style="display: none"
    >
      <i class="fa fa-arrow-circle-o-up"></i>
    </a>
  </article>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import InfiniteLoading from "vue-infinite-loading";
import Product from "./Product";
import productMixin from "../../../mixins/product";

export default {
  name: "Products",

  mixins: [productMixin],

  components: {
    Product,
    InfiniteLoading,
  },

  props: {
    centered: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters(["infiniteId", "products"]),
    showProducts() {
      return this.$parent.hasSelectedParentCollection && this.$parent.activeSubCollections.length > 0;
    },
  },

  mounted() {
    this.getProductsMinMax();

    $(window).on("scroll", function () {
      if ($(window).scrollTop() >= 310) {
        $(".products-filtered .shop-products .back-to-top").css(
          "display",
          "inline"
        );
      } else {
        $(".products-filtered .shop-products .back-to-top").css(
          "display",
          "none"
        );
      }
    });
  },

  methods: {
    ...mapMutations(["setImgLoading"]),
    ...mapActions(["renderProducts", "resetFilters"]),
    onInfinite($state) {
      this.renderProducts()
        .then((response) => {
          $state[response]();
        })
        .catch((error) => console.error(error))
        .then(this.getProductsMinMax);
    },
    getProductsMinMax() {
      Object.keys(this.products).map((i) => {
        this.products[i].minMaxQuantity = this.ProductMinMaxQuantity(
          this.products[i]
        );
        if (this.products[i].categories !== undefined) {
          this.products[i].isAkzo =
            this.products[i].categories.filter(
              (cat) => cat.code === "pris_akzonobel"
            ).length > 0;
        }
      });

      setTimeout(() => {
        this.setImgLoading(false);
      }, 2000);
    },
    scrollTo(element, offset = 50) {
      let target = 0;

      if (element !== "top") {
        target = $(element).offset().top - offset;
      }

      $("html, body").animate(
        {
          scrollTop: target,
        },
        500
      );
    },
    addSwatchToCart(swatch) {
      this.$emit("add-swatch-to-cart", swatch);
    },
  },
};
</script>

<style lang="scss">
#products {
  margin: 1% 0;

  .product-cards {
    margin: 0;
  }

  .back-to-top {
    margin: 0;
    position: fixed;
    bottom: 0;
    right: 20px;
    width: 70px;
    height: 70px;
    z-index: 100;
    display: none;
    text-decoration: none;
    color: rgb(249, 152, 57);
    background: transparent none;
    font-size: 70px;
    line-height: 68px;
    padding: 0 5px;

    &:hover {
      opacity: 0.6;
    }
  }
}
</style>
